import React, {useMemo} from 'react';
import {Chip, useTheme} from '@mui/material';
import type {PartValueRenderer} from 'schema/types';
import {type TaskType as TaskTypeType, TaskTypes} from 'services/tasks/types';
import {useLocalization} from 'localization';
import {px2rem} from 'theme';
import {NoWrap, Text} from 'components';

export const TaskType: PartValueRenderer = ({value}) => {
  const {tLoose} = useLocalization();
  const theme = useTheme();

  const types = value
    ? Array.isArray(value)
      ? (value as TaskTypeType[])
      : []
    : [];
  type TagTitleMap = {[key in TaskTypeType]: string};
  const tagTitles = useMemo(
    () =>
      TaskTypes.reduce<TagTitleMap>((acc, tag) => {
        acc[tag] = tLoose(`entity.task.type.short.${tag}`);
        return acc;
      }, {} as TagTitleMap),
    [tLoose],
  );

  return (
    <NoWrap>
      {types.map((tt: TaskTypeType) => {
        const title = tagTitles[tt];

        return (
          <Chip
            key={tt}
            label={
              <Text
                variant="body2"
                textTransform="none"
                mode={tt === 'ml' ? 'light' : undefined}>
                {title}
              </Text>
            }
            sx={{
              background: theme.status[tt],
              height: px2rem(29),
            }}
          />
        );
      })}
    </NoWrap>
  );
};
